<template>
<!-- 书房 -->
  <div class="book-list">
      <img class="bg" src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/booklist-bg.png" alt="">
      <!-- box -->
      <div class="book-main">
          <!-- header -->
          <div class="head">
              <img v-if="mailType==1" class="w370" src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/bk-h1.png" alt="">
              <img v-if="mailType==1" @click="mailHandle(2)" class="w300" src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/bk-h2.png" alt="">
              <img v-if="mailType==2"  @click="mailHandle(1)" class="w300" src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/bk-h1-on.png" alt="">
              <img v-if="mailType==2" class="w370" src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/bk-h2-on.png" alt="">
          </div>
          <!-- content -->
          <div class="content">
              <div class="list">
                <template v-if="mailType==1">
                    <template v-if="this.writeList.length>0">
                        <div  @click="showPosterHandle(item)" v-for="(item,index) in writeList" :key="index" :class="['child',mailMargin(index,'writeList')]">
                            <img  src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/book.png" alt="">
                            <p class="text-ellipsis-2">{{JsonToStr(item.data).name}}</p>
                            <button class="btn"><span>点击查看</span></button>
                        </div>
                    </template>
                    <div v-else class="small">
                        暂没有已写的信件哦~
                    </div>
                </template>
                <template v-if="mailType==2">
                    <template v-if="this.receivingList.length>0">
                        <div  @click="toMailView(item)" v-for="(item,index) in receivingList" :key="index" :class="['child',mailMargin(index,'receivingList')]">
                            <img  src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/book.png" alt="">
                            <p class="text-ellipsis-2">{{JsonToStr(item.data).name}}</p>
                            <button class="btn"><span>点击查看</span></button>
                        </div>
                    </template>
                    <div v-else class="small">
                        暂没有收到信件哦~
                    </div>
                </template>
              </div>
              <!-- btn -->
              <button class="addbtn" @click="$router.push('/ceping82')">继续写信</button>
          </div>
      </div>
      <!-- 生成一封信海报 -->
      <van-popup class="book-poster" v-model="posterShow"  :close-on-click-overlay="false">
          <div class="child">
              <img v-if="posterLink" :src="posterLink" alt="">
              <p>长按保存，发送给TA</p>
              <button @click="posterShow=false" class="btn">返回书房</button>
          </div>
      </van-popup>
  </div>
</template>

<script>
import { getData,saveData,ceping82_get_data_list,ceping82_info,ceping82_poster } from '@/api/measurement'
import { deepCopy,isMain } from "@/utils/tools";
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            // 类型，已写信还是已收信
            mailType:1,
            cid:82,
            writeList:[],
            receivingList:[],
            info:{},
            // 海报生成
            posterShow:false,
            posterLink:''
        }
    },
    methods:{
        // 查看已写信海报
        showPosterHandle(item){
            let obj = JSON.parse(item.data);
            if(!obj){
                this.$toast('对象数据错误！');
                return
            }
            //调用加载中
            this.$emit('loadingHandle',true,"海报生成中(◍°∇°◍)...");
            // 生成海报
            ceping82_poster({
                to:obj.name,
                from:this.info.nickname,
                date:obj.update_time?obj.update_time.split(' ')[0]:getNowFormatDate().replace(/-/g, "."),
                link:`https://open.xjy.cn/${isMain()?'main':'test'}/ceping82_mail?md5=${item.md5}&type=poster`,
                headimgurl:this.info.headimgurl
            }).then((res)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if (res.code == "10002") {
                    this.$toast(res.data.msg || res.msg || res.data.detail);
                    return
                }
                console.log(res)
                this.posterLink = res.poster;
                this.posterShow = true;
            });
        },
        // 查看已收信信件
        toMailView(item){
            this.$router.push({
                path:'/ceping82_mail',
                query:{
                    md5:item.md5
                }
            });
        },
        // 处理信件下边距
        mailMargin(index,str){
            return (this[str].length%2==0 && (index==this[str].length-1 || index==this[str].length-2))?'on':(index==this[str].length-1?'on':'');
        },
        // 切换写信或收信类型
        mailHandle(val){
            this.mailType = val;
            // if(val==2){
            //     this.getMailCollect();
            // }else{
            //     this.pullData();
            // }

        },
        // 转换json字符串位对象
        JsonToStr(val){
            if(!val){
                return {}
            }
            let obj = JSON.parse(val);
            return obj?obj:{}
        },
        // 获取已收信的
        getMailCollect(){
            //调用加载中
            this.$emit('loadingHandle',true,"正在获取信件ヾ(◍°∇°◍)ﾉﾞ...");
            getData({
                cid:this.cid
            }).then((data)=>{
                 //关闭加载中
                this.$emit('loadingHandle',false);
                if (data.code == "10002") {
                    this.$toast(data.data.msg || data.msg || data.data.detail);
                    return
                }
                let mailData = JSON.parse(data.data);
                let mailList =mailData && mailData.mailList?mailData.mailList:[];

                // 去除自己写的信
                this.receivingList = mailList.filter(item => {
                    let idList = this.writeList.map(v => v.md5)

                    return !idList.includes(item.md5)

                })
            });
        },
        // 初始化获取数据(已写信)
        pullData(){
            document.title = '我的书房';
            //调用加载中
            this.$emit('loadingHandle',true,"正在进入书房ヾ(◍°∇°◍)ﾉﾞ...");
            ceping82_get_data_list({
                cid:this.cid
            }).then((data)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if (data.code == "10002") {
                    this.$toast(data.data.msg || data.msg || data.data.detail);
                    return
                }
                this.writeList = data.list;
                
                
            });
            // 获取收件信息
            this.getMailCollect();
             // 第一次进来请求接口，如果已有头像和昵称数据不请求接口
            if(!this.info.nickname || !this.info.headimgurl){
                // 获取用户信息
                ceping82_info().then((data)=>{
                    if (data.code == "10002") {
                        this.$toast(data.data.msg || data.msg || data.data.detail);
                        return
                    }
                    this.info = data;
                });
            }
            shareCon("index", this);
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background:url('https://themes-cdn.xjy.cn/statics/career/images/ceping82/bg-cover.png') bottom;
    }
    .book-poster{
        background: transparent;
        text-align: center;
        img{
            width: 525px;
            margin-bottom: 30px;
            border-radius: 15px;
        }
        p{
            text-align: center;
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 33px;
            margin-bottom: 30px;
        }
        .btn{
            width: 300px;
            line-height: 80px;
            border: none;
            height: 80px;
            background: linear-gradient(180deg, #FF855D 0%, #D13E1D 100%);
            box-shadow: 0px 2px 6px 0px rgba(179, 31, 0, 0.43);
            border-radius: 40px;
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 50px;
            text-shadow: 0px 2px 4px rgba(221, 41, 0, 0.5);
        }
    }
</style>
<style lang="scss" scoped>
.book-list{
    position: relative;
    padding: 200px 0 40px;
    .bg{
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
    }
    .book-main{
        position: relative;
        z-index: 2;
        margin: 0 auto;
        width: 670px;
        border-radius: 30px;
        background-color: #FFEADD;
        overflow: hidden;
        text-align: center;
        .head{
            display: flex;
            align-items: center;
        }
        .content{
            padding: 30px 80px 120px;
            min-height: 850px;
            background-color: #FCFAF6;
            .list{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                .child{
                    position: relative;
                    text-align: center;
                    width: 200px;
                    height: 230px;
                    margin-bottom: 60px;
                    img{
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        z-index: 1;
                    }
                    p{
                        position: absolute;
                        width: 100%;
                        z-index: 2;
                        top: 50%;
                        transform: translateY(-50%);
                        text-align: center;
                        font-size: 28px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #875233;
                        padding: 0 15px;
                    }
                    .btn{
                        text-align: center;
                        width: 130px;
                        height: 32px;
                        background: linear-gradient(180deg, #FFEFBF 0%, #FEE28F 100%);
                        box-shadow: 0px 1px 6px 0px rgba(165, 124, 42, 0.2);
                        border-radius: 20px;
                        font-size: 18px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #875233;
                        border: none;
                        text-shadow: 0px 1px 6px rgba(165, 124, 42, 0.2);
                        position: absolute;
                        z-index: 2;
                        left: 50%;
                        transform: translateX(-50%);
                        bottom:13px;
                        span{
                            display: inline-block;
                            transform: scale(0.8);
                        }
                    }
                }
                .child.on{
                    margin-bottom: 276px;
                }
                .small{
                    flex: 1;
                    text-align: center;
                    font-size: 28px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #875233;
                    padding: 0 15px;
                    margin: 200px auto;
                }
            }
            .addbtn{
                width: 300px;
                height: 80px;
                background: linear-gradient(180deg, #FF855D 0%, #D13E1D 100%);
                box-shadow: 0px 2px 6px 0px rgba(179, 31, 0, 0.43);
                border-radius: 40px;
                font-size: 36px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #FFFFFF;
                text-shadow: 0px 2px 4px rgba(221, 41, 0, 0.5);
                border:none;
                animation: scaleDraw 2s  infinite;
            }
        }
        .w370{
            width: 370px;
        }
        .w300{
            width: 300px;
        }
    }
}
</style>